setInterval(() => {
  const freeSelectors = document.querySelectorAll('.cd-buy-button.cd-main-button');
  freeSelectors.forEach((freeSelector) => {
    if (freeSelector.textContent.trim() !== 'Add') { 
      freeSelector.textContent = 'Add';
    }
  });

}, 50);